import React, { useState, lazy, Suspense } from "react";
import { MDBIcon } from "mdb-react-ui-kit";
import { MDBDropdown, MDBDropdownMenu, MDBDropdownToggle, MDBDropdownItem } from 'mdb-react-ui-kit';
import LoadingOverlay from "../../../Components/LoadingOverlay";
import PopConfirm from "../../../Components/PopConfirm";
import useAxiosCall from "../../../Hooks/useAxiosCall";
import { decryptData, encryptData } from "../../../Utilities/CryptoUtility";
import Toast from "../../../Components/Toast";
import { SecureStorage } from "../../../Utilities/StorageEncryption";
const Actions = ({ index, userName, email, portal, actionParams }) => {

    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false);
    const [toastData, setToastData] = useState({ type: "", message: "", isOpen: false });
    const [portalType, setPortalType] =  useState(portal);
    const { makeApiCall } = useAxiosCall();

    const handleResetPasswordClick = () => {
        if(email && actionParams.pendingPasswordChange != "Unregistered"){
            setIsResetPasswordModalOpen(true);
        }
    };

    const handleModalClose = () => {
        setIsResetPasswordModalOpen(false);
    };

    const handleApiCallSuccess = (data,modalCloseFlag=false) => {
        setToastData({ type: "success", message: data.message, isOpen: true, position: 'top-right' });
    }

    const handleApiCallError = (errorMessage,modalCloseFlag=false) => {
        setToastData({ type: "danger", message: errorMessage, isOpen: true, position: 'top-right' });
    };

    const resetToastData = () => {
        setToastData({ type: "", message: "", isOpen: false });
    }

    const onConfirm = async () => {
        const requestData = {
            data: encryptData(JSON.stringify(
                {
                    email: email,
                    portal: portal,
                    userType: "siteadmin",
                    customer: SecureStorage.getItem('acctDbKey')
                }
            ))
        }

        try {
            await makeApiCall({
                requestData,
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'POST',
                url: 'resetUserPassword'
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    }

    const impersonate = async() => {
        const newParams = { customer: SecureStorage.getItem('acctDbKey'), domain:SecureStorage.getItem('domain') };
        const updatedParams = {...actionParams, ...newParams};

        const requestData = {
            data: encryptData(JSON.stringify(
                updatedParams
            ))
        };
        try {
            await makeApiCall({
                requestData,
                onSuccess: handleImpersonateApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'POST',
                url: 'impersonate',
                loader: true
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    }

    const handleViewAppApiCallSuccess = (encryptedData) => {
        let data = decryptData(encryptedData.data);
        let customer = SecureStorage.getItem('acctDbKey');
        window.open(data.data.url+"sa="+data.data.sa+"&account="+customer+"&id="+actionParams.applicationId, '_blank');
    };
    const handleImpersonateApiCallSuccess = (encryptedData) => {
        let data = decryptData(encryptedData.data);
        let customer = SecureStorage.getItem('acctDbKey');
        window.open(data.data.url+customer+"?q="+data.data.qToken, '_blank');
    };

    const viewApplication = async() => {
        const newParams = { customer: SecureStorage.getItem('acctDbKey'), domain:SecureStorage.getItem('domain') };
        const updatedParams = {...actionParams, ...newParams};

        const requestData = {
            data: encryptData(JSON.stringify(
                updatedParams
            ))
        };
        try {
            await makeApiCall({
                requestData,
                onSuccess: handleViewAppApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'POST',
                url: 'viewApplication',
                loader: true
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    }

    return (
        <>
            <Toast toast={toastData} resetToast={resetToastData} hasHeader={false}/>

            <MDBDropdown>
                <MDBDropdownToggle color="secondary"><MDBIcon icon="ellipsis-v" /> &nbsp;&nbsp;Action</MDBDropdownToggle>
                <MDBDropdownMenu>
                    <>
                    { (portalType != "prospect" && portalType != "prospectdocument" && portalType != "user" && portalType != "userupload" ) && <MDBDropdownItem link  title={(email  == "" || actionParams.pendingPasswordChange == "Unregistered") ? "Portal Email address or portal registration needed" : ""} onClick={impersonate}><MDBIcon icon="user-alt" />&nbsp;&nbsp; Impersonate</MDBDropdownItem>}
                    { (portalType != "prospect" && portalType != "prospectdocument" && portalType != "user" && portalType != "userupload")  && <MDBDropdownItem link disabled={(email == "" || actionParams.pendingPasswordChange == "Unregistered") ? true : false} title={(email  == "" || actionParams.pendingPasswordChange == "Unregistered" )? "Portal Email address or portal registration needed" : ""} onClick={handleResetPasswordClick} ><MDBIcon icon="key" />&nbsp;&nbsp; Forgot Password</MDBDropdownItem>}
                    { (portalType == "prospect" || portalType == "prospectdocument" )  && <MDBDropdownItem link onClick={viewApplication} ><MDBIcon icon="eye" />&nbsp;&nbsp; View Application</MDBDropdownItem>}
                    </>
                </MDBDropdownMenu>
            </MDBDropdown>
            {/* Reset Password Modal */}
            <Suspense fallback={<LoadingOverlay />}>
                {isResetPasswordModalOpen && (
                    <>
                        {email ? (
                            <PopConfirm
                                title={"Are you sure to send Reset Password Email to " + userName + "?"}
                                isOpen={isResetPasswordModalOpen}
                                onConfirm={onConfirm}
                                onClose={handleModalClose}
                            />
                        ) : (
                            <PopConfirm
                                title={`Portal email not found for  ${userName}`}
                                isOpen={isResetPasswordModalOpen}
                                onConfirm={handleModalClose}
                                onClose={handleModalClose}
                            />
                        )}
                    </>
                )}

            </Suspense>
        </>
    );
};

export default Actions;
